import message from 'components/utils/message';
import request from 'tools/request';

export function getPlans(
  params = {},
  fullData = false,
  setCompleted = () => {},
  currency = 'EUR'
) {
  return async (dispatch) => {
    let data = [];
    try {
      const response = await request(`/api/product/export`, {
        method: 'GET',
        params: {
          page: 1,
          pageSize: 1000,
          currency,
          type: 'S',
          category: 'servizi',
          subcategory: 'subscription',
          ...params,
        },
      });
      data = response.data;
      if (fullData) {
        const _data = {
          items: [],
        };
        await Promise.all(
          data.items.map((d) =>
            dispatch(
              getPlanById(d._id, (_d) => {
                _data.items.push(_d);
              })
            )
          )
        );
        _data.items = _data.items.sort((d1, d2) => {
          if (d1._id > d2._id) return -1;
          if (d1._id < d2._id) return 1;
          return 0;
        });
        data = _data;
      }
    } catch (err) {
      message.error("Can't load plans");
    }
    setCompleted(data);
  };
}

export function getPlanById(id, setCompleted = () => {}) {
  return async () => {
    let data = {};
    try {
      const response = await request(`/api/product/${id}`, { method: 'GET' });
      data = response.data;
    } catch (err) {
      message.error("Can't load plan");
    }
    setCompleted(data);
  };
}

export function getComputePlanOrderTotal({
  subscriptionId,
  planCode,
  onComplete = () => {},
}) {
  return () => {
    request(
      `/api/order/compute/service/total?subscription_id=${subscriptionId}&plan_code=${planCode}`
    )
      .then((response) => {
        onComplete(response.data);
      })
      .catch((err) => console.log(err));
  };
}

export function getShopifyDomain() {
  return (dispatch) => {
    request(`https://s-app.brandssync.com/restful/oauth/install`)
      .then((response) => {
        console.log(response.data);
      })
      .catch((err) => console.log(err));
  };
}

export function getWixCheckout(data) {
  return async () => {
    const response = await request(`/api/order/wix/checkout-url`, {
      method: 'POST',
      data,
    });
    return response.data;
  };
}
